import { get } from 'lodash/fp';
import Cookies from 'js-cookie';

export default (design, item) => {
  const estimateMode = {
    designId: get('designId')(design),
    estimateName: get('name')(design),
    itemId: get('itemId')(item),
    itemName: get('label')(item),
    action: 'add',
  };

  window.localStorage.setItem('estimateMode', JSON.stringify(estimateMode));
  /*
   This cookie added to be consumed by THD Nucleus PCP Experience
    since local storage is not cross domains.
  */
  const { designModeCookieDomain } = window.pageContextJavascript;
  const cookieSettings = { domain: designModeCookieDomain || undefined, sameSite: 'none', secure: true };
  Cookies.set('designMode', JSON.stringify(estimateMode), cookieSettings);
};

